// For more information about this file see https://dove.feathersjs.com/guides/cli/service.shared.html
import type { Params } from '@feathersjs/feathers';
import type { ClientApplication } from '../../client';
import type { Tspdt, TspdtData, TspdtPatch, TspdtQuery, TspdtService } from './tspdt.class';

export type { Tspdt, TspdtData, TspdtPatch, TspdtQuery };

export type TspdtClientService = Pick<
  TspdtService<Params<TspdtQuery>>,
  (typeof tspdtMethods)[number]
>;

export const tspdtPath = 'api/tspdt';

export const tspdtMethods: Array<keyof TspdtService> = ['find', 'get', 'patch', 'queryTspdt'];

export const tspdtClient = (client: ClientApplication) => {
  const connection = client.get('connection');

  client.use(tspdtPath, connection.service(tspdtPath), {
    methods: tspdtMethods,
  });
};

// Add this service to the client service type index
declare module '../../client' {
  interface ServiceTypes {
    [tspdtPath]: TspdtClientService;
  }
}
